module.exports = __webpack_public_path__ + "static/media/video-camera-alt.0808a097.svg";